import { CHEARCH_ARTICLE, FETCH_ARTICLES } from "../types";

export const articleReducer = (
  state = { isLoading: true, data: [] },
  action
) => {
  switch (action.type) {
    case FETCH_ARTICLES:
      return {
        isLoading: false,
        data: action.payload,
        filteredData: action.payload,
      };
    case CHEARCH_ARTICLE:
      // console.log("action", action.payload)
      return {
        ...state,
        filteredData: action.payload.items,
      };
    default:
      return state;
  }
};
